import { FC } from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";
import styles from "./index.module.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import {
  CustomerType,
  FrenetDeliveryMethodType,
  OrderAddress,
} from "../../contexts/OrderContext";
import Swal from "sweetalert2";
import { useToast } from "../../hooks/useToast";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { SumaryOrder } from "../../components/sumaryOrder/sumaryOrder.module";
import { ChooseAddressOrder } from "../../components/chooseAddressOrder/chooseAddressOrder";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import { CashbackInput } from "../../components/CashbackInput/cashbackInput";
import { CashbackEarnPreview } from "../../components/CashbackEarnPreview/cashbackEarnPreview";
import { useSellerCart } from "../../contexts/sellerCartContext";
import { VolumeFrenetType } from "./newOrderInfo.type";
import { useCustomer } from "../../contexts/customerContext/customerContext";
import { useOrderMetaData } from "../../contexts/orderMetaDataContext/orderMetaDataContext";
import { cpfCnpjNoMask } from "../../functions/mask";
import { useCashbackRedeem } from "../../hooks/useCashbackRedeem";
import { useCashbackEarn } from "../../hooks/useCashbackEarn";
import { useDiscount } from "../../hooks/useDiscount";

const NewOrderInfo: FC = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const sellerCartContext = useSellerCart();
  const { customer, customerAddress } = useCustomer();
  const { metadata, setFreightCost } = useOrderMetaData();
  const orderContext = useOrder();
  const { hasDiscount } = useDiscount();
  const hasCoupon = hasDiscount("coupon");
  const { getToken, getLocations, registerAccess } = usePluginspace();
  const toastComponent = useToast();

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const [findCep, setFindCep] = useState(false);

  const [isCounter, setIsCounter] = useState(false);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsChecked, setTotvsChecked] = useState(false);

  // Com TOTVS (105) able, não permite resgate/ganho/cálculo de cashback
  const cashbackAllowed = totvsChecked && !totvsVarejoAble;

  const {
    shouldShowCashback,
    availableBalance,
    redeemValue,
    setRedeemValue,
    hasCashback,
    appliedAmount,
    loading: loadingCashback,
    applyCashbackRedeem,
    clearCashbackRedeem,
  } = useCashbackRedeem({ enabled: cashbackAllowed });
  const {
    shouldShowEarn,
    earnAmount,
    loading: loadingEarn,
  } = useCashbackEarn({ enabled: cashbackAllowed });

  /*Valor do frete */
  const [valueWithDraw, setValueWithDraw] = useState(0);
  const [valueCep, setValueCep] = useState(0);
  const [cep, setCep] = useState<string>("");
  const [freightFind, setFreightFind] = useState(0);

  const [typeFreight, setTypeFreight] = useState("withdraw");
  const [customerAddresses, setCustomerAddresses] = useState([]);

  const [customerInfoComplete, setCustomerInfoComplete] = useState();
  const [frenetMethods, setFrenetMethods] = useState<
    FrenetDeliveryMethodType[]
  >([]);

  useEffect(() => {
    registerAccess("order");
    getConfig();
    const isCounterStorage = localStorage.getItem("counter_number");
    setIsCounter(isCounterStorage ? true : false);
  }, []);

  async function verifyTotvs() {
    try {
      const response = await api.post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 105,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );

      if (response.data.data.length > 0) {
        const configData = response.data.data[0];
        if (configData.content?.able === "1") {
          setTotvsVarejoAble(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTotvsChecked(true);
    }
  }

  async function loadOrder() {
    const freight = metadata.freightCost;
    const freightType =
      metadata.orderType === "delivery" ? "delivery" : "withdraw";

    setTypeFreight(freightType);

    if (customerAddress && customerAddress.cep) {
      await verifyFrenet(customerAddress.cep);
    }
    if (freightType === "delivery" && sellerCartContext.data) {
      /*Como salvamos o valor do frete do carrinho do vendedor  faremos a validaçao aqui*/
      let cepValueVendor = freight;
      const sellerCartFreight = sellerCartContext.getSellerCartFreight();
      if (sellerCartFreight !== null) {
        cepValueVendor = sellerCartFreight;
      }
      setFreightCost(cepValueVendor);
      setValueCep(cepValueVendor);

      setCep(metadata.deliveryAddress?.cep || "");
      setFindCep(true);
      setShouldUpdate(false);
    } else if (!valueCep && customerAddress && customerAddress.cep) {
      let value = 0;
      if (!findCep) {
        value = await findCepDeliveryCustomerCep(customerAddress.cep, true);
      }
    }

    const sellerCartFreight = sellerCartContext.getSellerCartFreight();
    if (sellerCartFreight !== null) {
      setValueCep(sellerCartFreight);
      setFreightCost(sellerCartFreight);
    }
  }

  async function getConfig() {
    setLoading(true);
    setLoadingHeader(true);
    const findedConfig: ConfigType | void = await getAppConfig();

    if (findedConfig) {
      const value = findedConfig!.content.pdv.withDrawFee
        ? parseFloat(findedConfig!.content.pdv.withDrawFee.toString())
        : 0;
      setValueWithDraw(value);
    }

    setLoadingHeader(false);
    setConfig(findedConfig);
    await verifyTotvs();
    await orderContext.synchronizeContextToStorage();
    await getCustomerAddresses();
    await loadOrder();

    setLoading(false);
  }

  async function nextStep() {
    try {
      const newLocation = await getLocations();

      const deliveryActive =
        config && config.content.pdv.internalDelivery ? true : false;

      const witdrawActive = newLocation.find(
        (location) => location.code === "withdraw",
      );

      if (!witdrawActive && !(deliveryActive && findCep)) {
        toastComponent.openToast(
          "warning",
          "Essa loja não possui formas de modalidades disponíveis",
          6000,
        );

        return null;
      }

      if (
        (typeFreight.includes("delivery") && findCep) ||
        typeFreight.includes("delivery-")
      ) {
        navigate(`/${pluginspace_id}/new-choose-payment`);
      } else if (typeFreight === "withdraw" && witdrawActive) {
        navigate(`/${pluginspace_id}/new-choose-payment`);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Selecione um meio de entrega válido",
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerAddresses() {
    try {
      if (!customer?.cpf) return;
      const cpfWithouthMask = cpfCnpjNoMask(customer.cpf);

      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: cpfWithouthMask,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setCustomerInfoComplete(data);
            setCustomerAddresses(data.customerAddresses);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function getConfigFrenet() {
    try {
      const response = await api.post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 119,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );

      const config = response.data.data.filter(
        (el: any) =>
          el.content?.deep &&
          el.content?.height &&
          el.content?.weight &&
          el.content?.width,
      );

      if (config.length > 0) {
        const { deep, height, weight, width } = config[0].content;
        return { deep, height, weight, width };
      }
      return null;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async function verifyFrenet(cep: string) {
    const orderNow = await orderContext.getOrder();
    if (orderNow && orderNow.products) {
      let volumes: VolumeFrenetType[] = [];
      let shipmentInvoiceValue = 0;

      // Obter os valores padrão
      const defaultValues = await getConfigFrenet();
      const height = defaultValues?.height || 0;
      const deep = defaultValues?.deep || 0;
      const weight = defaultValues?.weight || 0;
      const width = defaultValues?.width || 0;

      orderNow.products.forEach((prod) => {
        volumes.push({
          Height: prod.measures?.height || Number(height),
          Length: prod.measures?.lenght || Number(deep),
          Weight: prod.measures?.weight || Number(weight),
          Width: prod.measures?.width || Number(width),
          Quantity: prod.quantity,
          SKU: prod.sku,
        });
        shipmentInvoiceValue +=
          prod.unitPrice !== prod.promotionalPrice &&
          prod.promotionalPrice !== 0
            ? prod.promotionalPrice
            : prod.unitPrice;
      });
      return await api
        .post(
          "/api/frenet/quote",
          {
            recipientCep: cep,
            shipmentInvoiceValue,
            shippingItemArray: volumes,
            recipientCountry: "BR",
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          const frenetResponse = response.data;
          if (
            frenetResponse.success &&
            frenetResponse.data &&
            frenetResponse.data.ShippingSevicesArray &&
            frenetResponse.data.ShippingSevicesArray.length > 0
          ) {
            const newFrenetItens =
              frenetResponse.data.ShippingSevicesArray.filter(
                (frenetItem: FrenetDeliveryMethodType) => !frenetItem.Error,
              );
            setFrenetMethods(newFrenetItens);
            return newFrenetItens;
          } else {
            setFrenetMethods([]);
            return [];
          }
        })
        .catch((err) => {
          console.log(err);
          setFrenetMethods([]);
          return [];
        });
    }
  }

  async function findCepDeliveryCustomerCep(cep: string, noAlarm?: boolean) {
    let urlSearchValid = "";
    const findedConfig: ConfigType | void = await getAppConfig();
    if (findedConfig) {
      switch (findedConfig.content.pdv.restrictCep) {
        case "cep":
          urlSearchValid = `/api/zip-code/valid/${cep}`;
          break;
        case "area":
          urlSearchValid = `/api/delivery/valid/${cep}`;
          break;
        case "mapa":
          urlSearchValid = `/api/delivery-area/valid/${cep}`;
          break;
        default:
          urlSearchValid = `/api/zip-code/valid/${cep}`;
          break;
      }
    } else urlSearchValid = `/api/zip-code/valid/${cep}`;
    setLoading(true);
    const frenetItems = await verifyFrenet(cep);
    return await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;
        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setCep(cep);

          let cepValue = findedCeps[0].valor;

          const sellerCartFreight = sellerCartContext.getSellerCartFreight();
          if (sellerCartFreight !== null) {
            cepValue = sellerCartFreight;
          }
          setFreightCost(cepValue);
          setValueCep(cepValue);
          setShouldUpdate(false);
          setLoading(false);
          return findedCeps[0].valor;
        } else if (!noAlarm) {
          setLoading(false);

          setFindCep(false);
          return 0;
        }
      })
      .catch((err) => {
        setLoading(false);
        setFindCep(false);
        console.log(err);
        return 0;
      });
  }

  return (
    <div className={styles.order_info}>
      <div className={styles.content_order_info}>
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.content_order_info_content}>
            <div className={styles.content_order_info_content_body}>
              <CheckoutOrder position={2} name={"forma de entrega"} />
              <SumaryOrder page="informacao" />
              {cashbackAllowed && shouldShowEarn && (
                <CashbackEarnPreview
                  amount={earnAmount}
                  loading={loadingEarn}
                />
              )}
              {cashbackAllowed && shouldShowCashback && !hasCoupon && (
                <CashbackInput
                  redeemValue={redeemValue}
                  setRedeemValue={setRedeemValue}
                  availableBalance={availableBalance}
                  hasCashback={hasCashback}
                  appliedAmount={appliedAmount}
                  loading={loadingCashback}
                  disabled={hasCoupon}
                  onApply={applyCashbackRedeem}
                  onRemove={() => clearCashbackRedeem()}
                />
              )}
              <ChooseAddressOrder
                deliveryActive={
                  config && config.content.pdv.internalDelivery ? true : false
                }
                withDrawValue={valueWithDraw}
                deliveryDrawValue={valueCep}
                setCep={setCep}
                cep={cep}
                setTypeFreight={setTypeFreight}
                setFreightFind={setFreightFind}
                typeFreight={typeFreight}
                customerAddresses={customerAddresses}
                setAllcustomerAddresses={setCustomerAddresses}
                findCepDeliveryCustomerCep={findCepDeliveryCustomerCep}
                setFindCep={setFindCep}
                findCep={findCep}
                shouldUpdate={shouldUpdate}
                customerName={customer ? customer.name : ""}
                customerPhone={customer ? customer.phone : ""}
                customerInfoComplete={customerInfoComplete}
                frenetMethods={frenetMethods}
                config={config}
              />
            </div>
            {!loading && (
              <ButtonCheckout
                action={() => nextStep()}
                label={"Continuar"}
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                color={
                  config?.webappcolor.fontbutton
                    ? config?.webappcolor.fontbutton
                    : "#636363"
                }
                marginBottom
              />
            )}
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewOrderInfo };
